<div class="main-container">
  <div class="main-page">
    <div class="prospect-detail">
      <div class="d-grid grid-prospect">
        @if(prospecto?.nombre){
        <div>
          <div class="prospect-card">
            <div class="d-grid prospect-title">
              <div><h4 class="color-gray t-20">Prospecto</h4></div>
              <div class="d-grid card-buttons-1 align-self-end">
                <button
                  class="btn btn-primary"
                  (click)="openConvert(prospecto)"
                >
                  Convertir
                </button>
                <div class="menu-container">
                  <div
                    class="dropdown-container"
                    (click)="$event.stopPropagation()"
                  >
                    <button
                      (click)="toggleActionsMenu('menu-' + prospecto.id)"
                      class="btn btn-round-outline"
                    >
                      <img src="assets/svg/tridots.svg" class="center-svg" />
                    </button>
                    <div
                      class="dropdown-menu"
                      [class.show]="openedMenuId === 'menu-' + prospecto.id"
                    >
                      <button
                        *ngIf="permissionService.hasPermission('Clientes', 'Editar')"
                        class="dropdown-item"
                        (click)="openManageProspect(prospecto?.prospecto_id)"
                      >
                        Modificar
                      </button>
                      <button
                        *ngIf="permissionService.hasPermission('Clientes', 'Eliminar')"
                        class="dropdown-item"
                        (click)="openMdlDeleteProspect(prospecto?.prospecto_id)"
                      >
                        Eliminar
                      </button>
                      <button
                        *ngIf="permissionService.hasPermission('Clientes', 'Crear')"
                        class="dropdown-item"
                        (click)="openCreateProspect()"
                      >
                        Crear nuevo prospecto
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div class="d-grid prospect-name">
                <div><img src="assets/svg/name-icon.svg" alt="" /></div>
                <div>
                  <h2 class="text-semibold">
                    {{prospecto?.nombre}} {{prospecto?.apellido}}
                  </h2>
                </div>
              </div>
              <div class="d-flex flex-row gap-20">
                <div class="text-tag color-org text-center">
                  <b>Progreso:</b> Nuevo
                </div>
                <div class="text-tag color-org text-center">
                  <b>&Uacute;ltima actualizaci&oacute;n:</b> 10/07/2025
                </div>
              </div>
              <div class="d-grid card-buttons-2">
                <div class="text-center event-item">
                  <button
                    class="btn btn-round-outline"
                    (click)="openNewCall();"
                  >
                    <img class="center-svg" src="assets/svg/call-icon.svg" />
                  </button>
                  <h5>Llamada</h5>
                </div>
                <div class="text-center event-item">
                  <button
                    class="btn btn-round-outline"
                    (click)="openNewTask();"
                  >
                    <img class="center-svg" src="assets/svg/task-icon.svg" />
                  </button>
                  <h5>Tarea</h5>
                </div>
                <div class="text-center event-item">
                  <button
                    class="btn btn-round-outline"
                    (click)="openNewEvent()"
                  >
                    <img class="center-svg" src="assets/svg/event-icon.svg" />
                  </button>
                  <h5>Evento</h5>
                </div>
                <div class="text-center event-item">
                  <button
                    class="btn btn-round-outline"
                    (click)="openSendMail()"
                  >
                    <img class="center-svg" src="assets/svg/mail-icon.svg" />
                  </button>
                  <h5>Correo</h5>
                </div>
              </div>

              <div class="info-card">
                <div class="d-grid info-card-title">
                  <h3>Informaci&oacute;n</h3>
                  <div class="d-grid card-buttons-1">
                    <div *ngIf="!editInfo">
                      <img
                        src="assets/svg/edit.svg"
                        alt="Editar"
                        class="icon-clickable"
                        (click)="toggleEdit('info')"
                      />
                    </div>
                    <div *ngIf="editInfo" class="d-flex gap-10">
                      <button
                        class="btn btn-primary"
                        (click)="saveSection('info')"
                      >
                        Guardar
                      </button>
                      <button
                        class="btn btn-outline"
                        (click)="cancelEdit('info')"
                      >
                        Cancelar
                      </button>
                    </div>
                    <div class="d-grid">
                      <button
                        class="btn btn-round-outline-mini"
                        (click)="toggleSection('info')"
                      >
                        <img
                          class="center-svg arrow-toggle"
                          [class.rotated]="!showInfoSection"
                          src="assets/svg/arrow-up.svg"
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <div class="info-card-detail" *ngIf="showInfoSection">
                  <table class="info-table">
                    <tbody>
                      <tr>
                        <td>Compa&#241;&iacute;a:</td>
                        <td>
                          <ng-container *ngIf="!editInfo; else editEmpresa">
                            {{ prospecto?.empresa }}
                          </ng-container>
                          <ng-template #editEmpresa>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableProspect.empresa"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Sitio web:</td>
                        <td>
                          <ng-container *ngIf="!editInfo; else editSitio">
                            {{ prospecto?.sitio_web }}
                          </ng-container>
                          <ng-template #editSitio>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableProspect.sitio_web"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Industria:</td>
                        <td>
                          <ng-container *ngIf="!editInfo; else editIndustria">
                            {{ prospecto?.industria?.nombre || 'Sin industria'
                            }}
                          </ng-container>
                          <ng-template #editIndustria>
                            <select
                              class="crm-input"
                              [(ngModel)]="editableProspect.industria_id"
                            >
                              <option
                                *ngFor="let ind of proIndustries"
                                [value]="ind.industria_id"
                              >
                                {{ ind.nombre }}
                              </option>
                            </select>
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Cantidad empleados:</td>
                        <td>
                          <ng-container *ngIf="!editInfo; else editEmpleados">
                            {{ prospecto?.empleados }}
                          </ng-container>
                          <ng-template #editEmpleados>
                            <input
                              class="crm-input"
                              type="number"
                              [(ngModel)]="editableProspect.empleados"
                            />
                          </ng-template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="info-card mt-4">
                <div class="d-grid info-card-title">
                  <h3>Detalles prospecto</h3>
                  <div class="d-grid card-buttons-1">
                    <div *ngIf="!editDetails">
                      <img
                        src="assets/svg/edit.svg"
                        alt="Editar"
                        class="icon-clickable"
                        (click)="toggleEdit('details')"
                      />
                    </div>
                    <div *ngIf="editDetails" class="d-flex gap-10">
                      <button
                        class="btn btn-primary"
                        (click)="saveSection('details')"
                      >
                        Guardar
                      </button>
                      <button
                        class="btn btn-outline"
                        (click)="cancelEdit('details')"
                      >
                        Cancelar
                      </button>
                    </div>
                    <div class="d-grid">
                      <button
                        class="btn btn-round-outline-mini"
                        (click)="toggleSection('details')"
                      >
                        <img
                          class="center-svg arrow-toggle"
                          [class.rotated]="!showDetailsSection"
                          src="assets/svg/arrow-up.svg"
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <div class="info-card-detail">
                  <table class="info-table" *ngIf="showDetailsSection">
                    <tbody>
                      <tr>
                        <td>Nombre completo:</td>
                        <td>
                          <ng-container *ngIf="!editDetails; else editNombre">
                            {{ prospecto?.nombre }} {{ prospecto?.apellido }}
                          </ng-container>
                          <ng-template #editNombre>
                            <div class="d-flex gap-10">
                              <input
                                class="crm-input"
                                type="text"
                                placeholder="Nombre"
                                [(ngModel)]="editableProspect.nombre"
                              />
                              <input
                                class="crm-input"
                                type="text"
                                placeholder="Apellido"
                                [(ngModel)]="editableProspect.apellido"
                              />
                            </div>
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Cargo</td>
                        <td>
                          <ng-container *ngIf="!editDetails; else editCargo">
                            {{ prospecto?.cargo || '—' }}
                          </ng-container>
                          <ng-template #editCargo>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableProspect.cargo"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Correo:</td>
                        <td>
                          <ng-container *ngIf="!editDetails; else editCorreo">
                            {{ prospecto?.email || '—' }}
                          </ng-container>
                          <ng-template #editCorreo>
                            <input
                              class="crm-input"
                              type="email"
                              [(ngModel)]="editableProspect.email"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Tel&eacute;fono:</td>
                        <td>
                          <ng-container *ngIf="!editDetails; else editTelefono">
                            {{ prospecto?.telefono || '—' }}
                          </ng-container>
                          <ng-template #editTelefono>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableProspect.telefono"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Celular</td>
                        <td>
                          <ng-container *ngIf="!editDetails; else editCelular">
                            {{ prospecto?.celular || '—' }}
                          </ng-container>
                          <ng-template #editCelular>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableProspect.celular"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Direcci&oacute;n</td>
                        <td>
                          <ng-container
                            *ngIf="!editDetails; else editDireccion"
                          >
                            <span class="color-org">
                              {{ prospecto?.calle || '—' }}, {{ prospecto?.ciudad || '—' }}, {{ prospecto?.region || '—' }}
                            </span>
                          </ng-container>
                          <ng-template #editDireccion>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableProspect.calle"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Propietario <br />
                          del prospecto:
                        </td>
                        <td>
                          <div
                            class="d-grid proprietary-container align-items-center color-org"
                          >
                            <img src="assets/svg/avatar.svg" alt="" /><u
                              >{{prospecto?.ejecutivo.nombre}}
                              {{prospecto?.ejecutivo.apellido}}</u
                            >
                            <img
                              src="assets/svg/change-prospect.svg"
                              alt=""
                              (click)="openNewChangeOwner()"
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td>Origen del prospecto:</td>
                        <td>
                          <ng-container *ngIf="!editDetails; else editOrigen">
                            {{ prospecto?.origen || '—' }}
                          </ng-container>
                          <ng-template #editOrigen>
                            <select
                              class="crm-input"
                              [(ngModel)]="editableProspect.origen"
                            >
                              <option value="Publicidad">Publicidad</option>
                              <option value="Referencia">Referencia</option>
                              <option value="Web">Web</option>
                              <option value="Otro">Otro</option>
                            </select>
                          </ng-template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="info-card mt-4">
                <div class="d-grid info-card-title">
                  <h3>Historial registro</h3>
                  <div class="d-grid card-buttons-1">
                    <div class="d-grid">
                      <button
                        class="btn btn-round-outline-mini"
                        (click)="toggleSection('history')"
                      >
                        <img
                          class="center-svg arrow-toggle"
                          [class.rotated]="!showHistorySection"
                          src="assets/svg/arrow-up.svg"
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <div class="info-card-detail" *ngIf="showHistorySection">
                  <table class="info-table">
                    <tbody>
                      <tr>
                        <td>Creado por:</td>
                        <td>
                          <div
                            class="d-flex flex-row align-items-center color-org"
                          >
                            <img src="assets/svg/avatar.svg" alt="" /><u
                              >{{prospecto?.creadoPor.nombre}}
                              {{prospecto?.creadoPor.apellido}}</u
                            >
                          </div>
                        </td>
                        <td>
                          <div class="d-flex flex-row align-items-center">
                            {{prospecto?.fecha_creacion | date: 'dd-MM-yyyy
                            HH:mm'}}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Modificado por:</td>
                        <td>
                          <div
                            class="d-flex flex-row align-items-center color-org"
                          >
                            <img src="assets/svg/avatar.svg" alt="" /><u
                              >{{prospecto?.actualizadoPor.nombre}}
                              {{prospecto?.actualizadoPor.apellido}}</u
                            >
                          </div>
                        </td>
                        <td>
                          <div class="d-flex flex-row align-items-center">
                            {{prospecto?.fecha_actualizacion | date: 'dd-MM-yyyy
                            HH:mm'}}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        }
        <div class="prospect-info">
          <div class="main-open-tab">
            <div class="open-tab-title">
              <div class="d-grid tab-title-detail">
                <div><h3 class="text-semibold">Progreso</h3></div>
                <div class="justify-self-end">
                  <button
                    class="btn btn-primary"
                    (click)="updateProspectoStatus()"
                  >
                    Marcar etapa como completada
                  </button>
                </div>
              </div>
              <div class="d-grid progress-status mt-3">
                  @for(item of progreso_estado; track item){
                      <div [ngClass]="{
                          'status-number-one' : item.estado.orden === 1, 
                          'status-number-two' : item.estado.orden === 2, 
                          'status-number-three' : item.estado.orden === 3,
                          'active' : item.completado === true,
                          'inactive' : item.completado === false || item.completado === null,
                          'status-clicked' : markedStatus === item.estado.id_estado
                      }" (click)="markStatus(item.estado.id_estado)">
                          <span class="status-text">{{item.estado.nombre}} <br> <span class="status-date-1"> {{item.fecha_completado !== null ? (item.fecha_completado | date:'d MMMM y':'':'es' | titlecase) : 'Pendiente' }}</span> </span>
                      </div>
                  }
              </div>
            </div>
            <div class="open-tab-title mt-4">
              <div class="d-grid tab-title-detail">
                <div><h3 class="text-semibold">Actividad</h3></div>
                <div class="justify-self-end">
                  <button class="btn btn-round-outline">
                    <img class="center-svg" src="assets/svg/arrow-down.svg" />
                  </button>
                </div>
              </div>
              <div class="tab-body">
                <app-activities></app-activities>
              </div>
            </div>
            <div class="open-tab-title mt-4">
              <div class="d-grid tab-title-detail">
                <div><h3 class="text-semibold">Archivos (0)</h3></div>
                <div class="justify-self-end">
                  <button class="btn btn-round-outline">
                    <img class="center-svg" src="assets/svg/arrow-down.svg" />
                  </button>
                </div>
              </div>
            </div>
            <div class="open-tab-title mt-4">
              <div class="d-grid tab-title-detail">
                <div><h3 class="text-semibold">Notas (0)</h3></div>
                <div class="justify-self-end">
                  <button class="btn btn-round-outline">
                    <img class="center-svg" src="assets/svg/arrow-down.svg" />
                  </button>
                </div>
              </div>
            </div>
            <div class="open-tab-title mt-4">
              <div class="d-grid tab-title-detail">
                <div><h3 class="text-semibold">Tareas (0)</h3></div>
                <div class="justify-self-end">
                  <button class="btn btn-round-outline">
                    <img class="center-svg" src="assets/svg/arrow-down.svg" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
